// extracted by mini-css-extract-plugin
module.exports = {"carouselBase":"styles_carouselBase__UneM9","carousel":"styles_carousel__jbCCQ","pagination":"styles_pagination__AHvfB"};